import { FeedbackStatus, getFeedbackStatusColor, getFeedbackStatusLabel } from '../../types/api/feedback';
import { ActionMenu, ActionList } from '@primer/react';
import { ChevronDownIcon } from '@primer/octicons-react';

interface FeedbackStatusButtonProps {
    isDisabled: boolean
    currentStatus: FeedbackStatus;
    onStatusChange: (status: FeedbackStatus) => void;
}

export function FeedbackStatusButton({ isDisabled, currentStatus, onStatusChange }: FeedbackStatusButtonProps) {
    return (
        <ActionMenu>
            <ActionMenu.Anchor>
                <div
                    className='h-8'
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '4px',
                        padding: '4px 8px',
                        minWidth: '168px',
                        backgroundColor: 'white',
                        border: '1px solid #d0d7de',
                        borderRadius: '6px',
                        fontSize: '14px',
                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                        opacity: isDisabled ? 0.6 : 1,
                        pointerEvents: isDisabled ? 'none' : 'auto'
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <span
                            style={{
                                display: 'inline-block',
                                width: '8px',
                                height: '8px',
                                borderRadius: '50%',
                                marginTop: '1px',
                                backgroundColor: getFeedbackStatusColor(currentStatus)
                            }}
                        />
                        {getFeedbackStatusLabel(currentStatus)}
                    </div>
                    <ChevronDownIcon size={16} />
                </div>
            </ActionMenu.Anchor>
            <ActionMenu.Overlay>
                <ActionList>
                    {Object.values(FeedbackStatus).map((status) => (
                        <ActionList.Item
                            key={status}
                            onSelect={() => onStatusChange(status)}
                        >
                            <span
                                style={{
                                    display: 'inline-block',
                                    width: '12px',
                                    height: '12px',
                                    borderRadius: '50%',
                                    backgroundColor: getFeedbackStatusColor(status),
                                    marginRight: '8px'
                                }}
                            />
                            {getFeedbackStatusLabel(status)}
                        </ActionList.Item>
                    ))}
                </ActionList>
            </ActionMenu.Overlay>
        </ActionMenu>
    );
}

